// fadeInCascade
function fadeInCascade(selector, duration, delay) {
  var $ = jQuery;
  if (typeof selector === 'undefined') {
    return false;
  }
  duration = typeof duration === 'number' ? duration : 1000;
  delay = typeof delay === 'number' ? delay : 300;

  $(selector).each(function (index) {
    $(this)
      .delay(delay * index)
      .fadeIn(duration);
  });

  return true;
}

var window_height = jQuery(window).height();
var shop_by_offset = jQuery('#shop_by').offset().top + jQuery('#shop_by').height() / 2;

// Enable Re Nutriv theme
jQuery('body').addClass('brand-renutriv');

// Fade in Section 1
fadeInCascade('#section_1 div.div_content > *');

// Open Section 2
jQuery('#section_1 a.div_controls_open')
  .delay(1110)
  .fadeIn(900)
  .click(function (e) {
    var $ = jQuery;
    e.preventDefault();
    if ($('#section_2').hasClass('opened')) {
      return;
    }

    // Open
    $('#section_2').addClass('opened').animate({ height: 'toggle' });

    // Show contents
    fadeInCascade('#section_2 div.div_content > *');

    // Swap controls
    $(this).fadeOut(300, function () {
      $('#section_2 a.div_controls_close').fadeIn(900);
    });

    // Expand paralax
    $('#nonmodal_parallax .keyhole.nonmodal').height('50px');

    shop_by_offset = $('#shop_by').offset().top + $('#shop_by').height() / 2;
    console.log('line 42:' + shop_by_offset);
  });

// Close Section 2
jQuery('#section_2 a.div_controls_close').click(function (e) {
  var $ = jQuery;
  e.preventDefault();
  if (!$('#section_2').hasClass('opened')) {
    return;
  }

  // Close
  $('#section_2').removeClass('opened').animate({ height: 'toggle' });

  // Hide contents
  $('#section_2 div.div_content > *').fadeOut('fast');

  // Swap controls
  $(this).fadeOut(300, function () {
    $('#section_1 a.div_controls_open').fadeIn(900);
  });

  // Shrink paralax
  $('#nonmodal_parallax .keyhole.nonmodal').height('25px');

  shop_by_offset = $('#shop_by').offset.top() + $('#shop_by').height() / 2;
  console.log('line 62:' + shop_by_offset);
});

// Fade In Section on scroll
jQuery(window).on('scroll.shopby', function () {
  var $ = jQuery;
  if ($(this).scrollTop() + window_height >= shop_by_offset) {
    console.log($(this).scrollTop() + window_height, shop_by_offset, window_height);
    fadeInCascade('div#shop_by.renutriv_content div > *');
    $(this).off('scroll.shopby');
  }
});

jQuery('#nonmodal_parallax').clone().attr('id', 'nonmodal_parallax_2').prependTo('#section_2');
